export const DEACTIVATE_LENDERS = 'DEACTIVATE_LENDERS';
export const UPDATE_CREDIT_DECISION_LENDER_WITH_ADDRESS = 'UPDATE_CREDIT_DECISION_LENDER_WITH_ADDRESS';
export const UPDATE_TITLING_LENDER_WITH_ADDRESS = 'UPDATE_TITLING_LENDER_WITH_ADDRESS';

export const FETCH_LENDER_LIST_REQUEST = 'FETCH_LENDER_LIST_REQUEST';
export const FETCH_LENDER_LIST_SUCCESS = 'FETCH_LENDER_LIST_SUCCESS';
export const FETCH_LENDER_LIST_FAILURE = 'FETCH_LENDER_LIST_FAILURE';
